import React, {useState, useContext, useEffect, useMemo} from 'react';
import Spinner from '../../../../components/Spinner';
import TablePagination from '../../../TablePagination';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import NotFound from '../../../NotFound';
import {getCategoriasReport} from '../../../../pages/requests';
import axios from 'axios';

function ReportTable() {
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const {utilizador, rep, isCard, openCards, formatarNumero} = useContext(Context);
    const {t} = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalProdutos, setTotalProdutos] = useState(0);
    const [semDados, setSemDados] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [reportTitle, setReportTitle] = useState([]);
    console.log(reportData, 'report');

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        getCategoriasReport(lang)
            .then(res => {
                console.log(res.data.objetivos);
                setReportData(res.data.objetivos);
                setReportTitle(res.data.objetivos[0].objetivos);
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const ITEMS_PER_PAGE = 15;

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    return (
        <div>
            <div className="mb-5 mt-4">
                <span className="bg-gray-100 py-2 px-16 rounded-[8px] font-semibold dark:text-white dark:bg-gray-600">{t('relatorios')}</span>
            </div>
            {isMobile || isCard ? (
                <div>
                    {reportData?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row">{dados.representante.nome}</div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4 flex flex-row">
                                    <div className="text-gray-500 flex flex-col">
                                        {reportTitle.map(data => (
                                            <div className="font-medium text-gray-400 mr-2">{data.nome}:</div>
                                        ))}
                                    </div>

                                    <div className="text-gray-500 flex flex-col">
                                       
                                        {dados.objetivos.map(e => (
                                            <div className="font-medium text-gray-900 dark:text-gray-100 mr-2">
                                                {e.valorAtual} / {e.valorObjetivo}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}
                    {/* <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav> */}
                </div>
            ) : (
                <div className="relative  overflow-x-auto shadow-md sm:rounded-[8px] z-0">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    {t('representante')}
                                </th>
                                {reportTitle.map(
                                    dados => (
                                        // dados.objetivos.map(e => (
                                        <th scope="col" className="px-6 py-3">
                                            {dados.nome}
                                        </th>
                                    ),
                                    // )),
                                )}
                            </tr>
                        </thead>

                        <tbody>
                            {reportData.map(dados => (
                                <>
                                    <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 border-b dark:bg-gray-800 dark:border-gray-600 ">
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.representante.nome}
                                        </th>
                                        {dados.objetivos.map(e => (
                                            <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {e.valorAtual} / {e.valorObjetivo}
                                            </th>
                                        ))}
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                    {semDados && !loading && <NotFound frase={t('semRegistos')} />}
                    {loading && (
                        <div className="flex flex-row mt-14 mb-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    {/* <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav> */}
                </div>
            )}
        </div>
    );
}

export default ReportTable;
